import * as React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { buildTranslator, CustomForm, rng } from '../../../amorg-common';
import { getCustomFormPublic, startCustomFormAnswerPublic } from '../../../api/customFormClientApi';
import { Button } from '../../../designSystem/button/Button';
import { ButtonRow } from '../../../designSystem/button/ButtonRow';
import { SingleColumnLayout } from '../../_layouts/SingleColumnLayout';
import { LoadingPageOverlay } from '../../../designSystem/LoadingPageOverlay';
import { PageHeader } from '../../../designSystem/PageHeader';
import { P } from '../../../designSystem/typography/Body';
import { parseSiteScopedRouteParam } from '../../../utils/parseSiteScopedRouteParam';
import { PublicPageWrapper } from '../../_pageWrappers/PublicPageWrapper';

export function CustomFormStartAnswerPublicPage (): JSX.Element
{
    const params = useParams<{ keySiteId: string; }>();
    const keyRouteParams = parseSiteScopedRouteParam(params.keySiteId);

    const [state, setState] = React.useState<{
        loading: boolean,
        form: CustomForm | null,
        answerId: string;
    }>({
        loading: true,
        form: null,
        answerId: ''
    });

    const paramsKey = keyRouteParams.value;
    const paramsSiteId = keyRouteParams.siteId;

    React.useEffect(() =>
    {
        const getData = async () =>
        {
            const form = await getCustomFormPublic(paramsKey, paramsSiteId);
            setState({ loading: false, form, answerId: '' });
        };
        getData();
    }, [paramsKey, paramsSiteId]);

    async function handleClickStart ()
    {
        setState({ ...state, loading: true });
        const answerId = rng.getRandomId();
        const answerResult = await startCustomFormAnswerPublic(paramsKey, paramsSiteId, answerId);
        if (answerResult.isSuccess)
        {
            setState({ ...state, answerId, loading: false });
        }

    }

    const translator = buildTranslator('da');

    return (

        <PublicPageWrapper siteId={paramsSiteId}>
                <PageHeader headerText="Opret ny besvarelse" headerStyle="secondary-gray" narrow />
                <SingleColumnLayout narrow>
                    <>

                        {state.answerId &&
                            <Navigate to={`/customForms/public/${paramsSiteId}/${state.answerId}`} />
                        }


                        <LoadingPageOverlay loading={state.loading} />

                        {state.form &&
                            <article>
                                <P verticalMargin='40px' style={{ whiteSpace: 'pre-wrap' }}>{translator(state.form?.introText)}</P>


                                <ButtonRow variant='stretched'>
                                    <Button variant="filled" size="42px" text="Opret en besvarelse"
                                        onClick={handleClickStart} />
                                </ButtonRow>
                            </article>
                        }

                    </>
                </SingleColumnLayout>

        </PublicPageWrapper>
    );
}